module.exports = __webpack_public_path__ + "img/pricing-Illustration.29a48c76.svg";